import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AppSimpleTable from "components/ui/AppSimpleTable";
import AppTag from "components/ui/AppTag";

const ViewPaymentTable = ({ paymentLink }) => {
  const { t } = useTranslation();
  const { currentLanguage } = useSelector((state) => state.LanguageSlice);
  const PAID_STATUS = "PAID";

  const renderStatus = (val) => (
    <AppTag variant={val === PAID_STATUS ? "success" : "warning"}>{val === PAID_STATUS ? t("Paid") : t("Pending")}</AppTag>
  );
  
  const columns = [
    {
      title: t("Created by"),
      dataIndex: "createdBy",
      key: "name",
    },
    {
      title: t("Creation date"),
      dataIndex: "paymentDate",
      align: "initial",
      key: "paymentDate",
      render: (val, row, index) => {
        return moment.unix(row.linkCreationDate).format("DD/MM/YYYY");
      },
    },
    {
      title: t("Amount"),
      dataIndex: "amount",
      key: "amount",
      render: (val) => {
        return new Intl.NumberFormat(currentLanguage, {
          style: "currency",
          currency: "AED",
        }).format(val);
      },
    },
    // {
    //   title: t("Payment gateway"),
    //   dataIndex: "paymentGateway",
    //   key: "paymentGateway",
    //   render: (val) => {
    //     return <PaymentGatewayTag gateway={val} />;
    //   },
    // },
    {
      title: t("Payment link id"),
      dataIndex: "cartId",
      key: "paymentId",
    },
    {
      title: t("Status"),
      dataIndex: "linkStatus",
      key: "status",
      render: renderStatus,
    },
  ];

  return (
    <div className=" w-full ">
      <div className="overflow-hidden overflow-x-auto md:overflow-hidden">
        {paymentLink && (
          <AppSimpleTable
            columns={columns}
            data={paymentLink}
            pagination={false}
            size="small"
          />
        )}
      </div>
    </div>
  );
};

export default ViewPaymentTable;
